module.exports = __webpack_public_path__ + "static/media/glass-whiskey.c0436a77.svg";